<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { DepositAllocation, ElectronicInvoiceStatusHistory } from '../../../../Types/invoice'

defineProps<{
  histories: ElectronicInvoiceStatusHistory[]
}>()

const { d, n, t } = useI18n()

function enumLabel(prefix: string, value: string | null): string {
  return value ? t(`invoice.electronic_invoice.${prefix}.${value.toUpperCase()}.label`) : '-'
}
</script>

<template>
  <div class="table-responsive">
    <table class="table table-striped mb-0">
      <thead>
        <tr>
          <th class="font-weight-bold col-2">{{ t('invoice.electronic_invoice.label.status') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.electronic_invoice.label.createdAt') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.electronic_invoice.label.reason') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.electronic_invoice.label.internalStatus') }}</th>
          <th class="font-weight-bold col-2">{{ t('invoice.electronic_invoice.label.comment') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="history in histories" :key="history.id">
          <td>{{ enumLabel('status', history.status) }}</td>
          <td>{{ d(new Date(history.statusAt), 'date') }}</td>
          <td>{{ enumLabel('reason', history.reason) }}</td>
          <td>{{ enumLabel('internal_status', history.internalStatus) }}</td>
          <td>{{ history.comment || '-' }}</td>
        </tr>
        <tr v-if="!histories?.length">
          <td colspan="7" class="text-center">
            {{ t('invoice.title.emptyElectronicInvoiceStatusHistory') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
